export const cilDollar = ["24 24","<path d='M13.875 11.25h-3.75c-0.001 0-0.002 0-0.003 0-1.197 0-2.167-0.97-2.167-2.167s0.97-2.167 2.167-2.167c0.001 0 0.002 0 0.003 0h6v-1.5h-3.188v-2.792h-1.5v2.792h-1.313c-0.001 0-0.003 0-0.004 0-2.025 0-3.667 1.642-3.667 3.667s1.642 3.667 3.667 3.667c0.001 0 0.003 0 0.004 0h3.75c1.196 0.001 2.165 0.971 2.167 2.167v0.167c-0.001 1.196-0.971 2.165-2.167 2.167h-6.347v1.5h3.91v2.625h1.5v-2.625h0.938c2.024-0.002 3.664-1.643 3.667-3.666v-0.167c-0.002-2.024-1.643-3.664-3.666-3.667h-0z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-dollar.js
// module id = null
// module chunks = 